import './Dialog-fc0b21c7.css';

var classes = {"Overlay":"prc-DialogV1-Overlay-8fcHY","CloseIcon":"prc-DialogV1-CloseIcon-B1Z79","Dialog":"prc-DialogV1-Dialog-5Fgol","Header":"prc-DialogV1-Header-o4U-V"};

export { classes as default };
